import { store } from "../store";

export default (to: any, from: any, next: any) => {
  var session = store.getters.session;
  if (session.user.acesso == 4) {
    return next();
  } else {
    return next(`/401`);
  }
};
